/* Healthy Choice General Store — global behaviour */
(function () {
  'use strict';

  /* ---------- sticky header shadow ---------- */
  var header = document.querySelector('[data-hc-header]');
  if (header) {
    var overlays = header.classList.contains('hc-hdr--over');
    window.addEventListener('scroll', function () {
      // A transparent header sitting over a full-height hero should only turn
      // solid once the hero has scrolled past; a normal header snaps at once.
      var trigger = overlays ? (window.innerHeight - 120) : 8;
      header.classList.toggle('is-stuck', window.scrollY > trigger);
    }, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  function drawer(openSel, panelSel) {
    var panel = document.querySelector(panelSel);
    var scrim = document.querySelector('[data-hc-scrim]');
    if (!panel) return;
    function set(open) {
      panel.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      var opener = document.querySelector(openSel);
      if (opener) opener.setAttribute('aria-expanded', String(open));
    }
    document.querySelectorAll(openSel).forEach(function (b) {
      b.addEventListener('click', function () { set(true); });
    });
    panel.querySelectorAll('[data-hc-close]').forEach(function (b) {
      b.addEventListener('click', function () { set(false); });
    });
    if (scrim) scrim.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') set(false);
    });
  }
  drawer('[data-hc-menu-open]', '[data-hc-menu]');
  drawer('[data-hc-cart-open]', '[data-hc-cart]');
  drawer('[data-hc-search-open]', '[data-hc-search]');

  /* ---------- AJAX add to cart ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-hc-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-hc-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartCount();
        if (btn) { btn.textContent = 'Added ✓'; }
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        }, 1400);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        form.submit();
      });
  });

  /* ---------- scroll reveal ---------- */
  var targets = document.querySelectorAll('.hc-reveal');
  if ('IntersectionObserver' in window && targets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  } else {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  }
})();
